import { render, staticRenderFns } from "./UsageTermsFilter.vue?vue&type=template&id=5508764a&scoped=true"
import script from "./UsageTermsFilter.vue?vue&type=script&lang=js"
export * from "./UsageTermsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508764a",
  null
  
)

export default component.exports